export default "__VITE_ASSET__1ace6197__"